// import { useEffect } from 'react';
import { useEffect } from 'react';
import { useDisclosure, useMultiStyleConfig } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import Box from '../../Box/Box';
import DatePicker, { DateRange, useDateRange } from '../../DatePicker/DatePicker';
import Icon from '../../Icon/Icon';
import Text from '../../Text/Text';
import { useFilterContext } from '../Filter.context';
import { FilterStyle } from '../Filter.theme';

export type FilterDateProps = {
  category: string;
};

const FilterDate = (props: FilterDateProps) => {
  const { category } = props;
  const filterStyle = useMultiStyleConfig('Filter') as FilterStyle;

  const { isLoading, onFilterChange, onFilterClear, setPopoverOpen, state, data } = useFilterContext();

  const { isOpen, onClose, onToggle } = useDisclosure();

  const value = state[category];

  const onDateRangeApply = (range: DateRange) => {
    if (range.from && range.to) {
      onFilterChange('date_range', [String(range.from.toMillis()), String(range.to.endOf('day').toMillis())]);
    }
  };

  const onClearClick = () => {
    onFilterClear('date_range');
    onClose();
  };

  useEffect(() => {
    setPopoverOpen(isOpen);
  }, [isOpen]);

  const now = DateTime.local();
  const twoYearsAgo = now.minus({ years: 2 });

  const selectable = useDateRange(twoYearsAgo, now);

  const selectedRange: DateRange | undefined =
    value && value[0]
      ? new DateRange(DateTime.fromMillis(Number(value[0])), DateTime.fromMillis(Number(value[1])))
      : undefined;

  const label = selectedRange
    ? `${selectedRange.from?.toFormat('LLL dd')} - ${selectedRange.to?.toFormat('LLL dd')}`
    : 'All dates';

  return (
    <DatePicker
      selectable={data.date_range.selectable || selectable}
      onApply={onDateRangeApply}
      onClear={value?.length ? onClearClick : undefined}
      onClose={onClose}
      dayTooltip={data.date_range.dayTooltip}
      selected={selectedRange}
      visible={isOpen}
      mode="range"
    >
      <Box position={isOpen ? 'relative' : undefined} sx={filterStyle.item} zIndex={isOpen ? 'dialog' : undefined}>
        <Text as="button" disabled={isLoading} onClick={onToggle} size="2" sx={filterStyle.tagEdit} type="button">
          <Icon color="neutral.60" name="Calendar" size="16" /> {label}
          <Icon name="ChevronDown" size="16" />
        </Text>
      </Box>
    </DatePicker>
  );
};

export default FilterDate;
